import { emperor } from "~/services";

export const getBuildingReports = async (
    buildingId: string,
    date: string
) => {
    return await emperor.get('report/get-report', {
        params: {
            buildingId,
            date
        }
    });
};
